"use client";

import { Icon } from "@iconify/react";

/**
 * Le drapeau rond d'un pays, d'après son code ISO à deux lettres.
 *
 * Un dessin, et pas le caractère drapeau : Windows n'affiche pas les drapeaux
 * en emoji, il écrit les deux lettres du pays à la place. La collection
 * « circle-flags » d'Iconify est servie comme les icônes Solar du site.
 *
 * Décoratif : le nom du pays est toujours écrit à côté.
 */
export default function CountryFlag({ code, className = "h-4 w-4" }) {
    if (!/^[A-Za-z]{2}$/.test(code || "")) return null;

    return (
        <Icon
            icon={`circle-flags:${code.toLowerCase()}`}
            className={`shrink-0 rounded-full ${className}`}
            aria-hidden="true"
            // La place est réservée : le nom du pays ne se décale pas quand le drapeau arrive.
            fallback={<span className={`inline-block shrink-0 rounded-full bg-gray-200 dark:bg-grayDark-700 ${className}`} aria-hidden="true" />}
        />
    );
}

/** Le nom d'un pays dans la langue de la page : « SN » → « Sénégal ». */
export function countryName(code, locale = "fr") {
    try {
        return new Intl.DisplayNames([locale === "en" ? "en" : "fr"], { type: "region" }).of(code.toUpperCase()) || code;
    } catch {
        return code;
    }
}
